import usePaymentData from './hooks/usePaymentData'
import { useHistory } from 'react-router-dom'
import Payment from 'components/Payments'
import React, { useState } from 'react'
import PayExtraForm from './Form'
import './style.scss'

export type SelectedPeriods = Record<string, number>
type Page = {
  type: 'init'
} | {
  type: 'payment'
  amount: number
}

interface Invoice {
  invoiceId: string
  amount: string
  object?: string
}

interface PayExtraProps {
  isPopup?: boolean
}

const PayExtra: React.FC<PayExtraProps> = ({ isPopup }) => {
  const [page, setPage] = useState<Page>({ type: 'init' })
  const [selectedPeriods, selectPeriods] = useState<SelectedPeriods>({})
  const { isLoading, data, generateInvoice } = usePaymentData()

  const { goBack } = useHistory()
  const getInvoices = async (payment: payments.Payment) => {
    const invoices: Invoice[] = []
    const documentResponse = await generateInvoice([payment], selectedPeriods, 'invoice')
    if (documentResponse?.newDocuments) {
      documentResponse.newDocuments.forEach(({ id, toPay, object }) =>
        invoices.push({ invoiceId: id, amount: toPay, object })
      )
    }
    return invoices
  }

  if (page.type === 'payment') {
    return (
      <Payment
        grossPrice={page.amount}
        getInvoices={getInvoices}
        secondaryTheme={!!isPopup}
        close={(remotePaymentId?: string) => {
          if (remotePaymentId) {
            setTimeout(goBack, 100)
          } else {
            setPage({ type: 'init' })
          }
        }}
      />
    )
  }

  return (
    <div className={`payExtra${isPopup ? ' --secondary' : ''}`}>
      <PayExtraForm
        data={data}
        isPopup={isPopup}
        isLoading={isLoading}
        selectedPeriods={selectedPeriods}
        selectPeriods={selectPeriods}
        finalize={amount => {
          setPage({ type: 'payment', amount })
        }}
      />
    </div>
  )
}

export default PayExtra